import React, { useState } from "react";
import Autosuggest from "react-autosuggest";
import { getAirportsDetails } from "app/services/charterService";

const AirportDeparture = ({ index, setFieldValue }) => {
  const [value, setValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const getSuggestions = async (value) => {
    const inputValue = value.trim().toLowerCase();
    if (!inputValue) return [];

    const { data } = await getAirportsDetails(value);

    return data.map((detail) => ({
      id: detail.id,
      label: `${detail.cityName} ${detail.cityCode}`,
    }));
  };

  const onSuggestionSelected = (id, suggestionValue) => {
    setValue(suggestionValue.label);
    setFieldValue(id, suggestionValue.id);
  };

  const getSuggestionValue = (suggestion) => suggestion;

  const renderSuggestion = (suggestion) => <div>{suggestion.label}</div>;

  const onChange = (event, { newValue }) => {
    setValue(newValue);
    setFieldValue(`flightLegs.return[${index}].airportDepartureId`, "");
  };

  const onSuggestionsFetchRequested = async ({ value }) => {
    const data = await getSuggestions(value);
    setSuggestions(data);
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const inputProps = {
    value,
    onChange,
    className: "form-control",
    placeholder: "Airport Departure",
    id: `flightLegs.return[${index}].airportDepartureId`,
    name: `flightLegs.return[${index}].airportDepartureId`,
  };

  return (
    <div>
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
        onSuggestionSelected={(event, { suggestionValue }) =>
          onSuggestionSelected(
            `flightLegs.return[${index}].airportDepartureId`,
            suggestionValue,
          )
        }
      />
    </div>
  );
};

export default AirportDeparture;
